var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIBlackPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 0C31.4025 0.133888 20.7972 4.60186 12.9496 12.4496C5.10186 20.2972 0.633888 30.9025 0.5 42C0.633888 53.0975 5.10186 63.7028 12.9496 71.5504C20.7972 79.3981 31.4025 83.8661 42.5 84C53.5975 83.8661 64.2028 79.3981 72.0504 71.5504C79.8981 63.7028 84.3661 53.0975 84.5 42C84.3661 30.9025 79.8981 20.2972 72.0504 12.4496C64.2028 4.60186 53.5975 0.133888 42.5 0ZM66.5 45H45.5V66H39.5V45H18.5V39H39.5V18H45.5V39H66.5V45Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBlackPlus);
export default __webpack_public_path__ + "static/media/i-black-plus.b57931bacedcf82594798e76fd8f4e3d.svg";
export { ForwardRef as ReactComponent };